<template>

  <div class="view_box">
    <div ref="chart" class="map_box"></div>


    <!--详情弹窗-->
    <div ref="customTooltip"
         class="custom-tooltip"
         v-show="tooltipVisible">
      <div class="tooltip_view_box">

        <!-- 1 兵工场 -->
        <TooltipBgc v-if="module==1" :timeLabelLocal="timeLabelLocal" :tData="currentTooltipData"
                    :hideCustomTooltip="hideCustomTooltip"/>
        <!-- 3 分销者 -->
        <TooltipFxz v-if="module==3" :timeLabelLocal="timeLabelLocal" :tData="currentTooltipData"
                    :hideCustomTooltip="hideCustomTooltip"/>
        <!-- 4 产品 -->
        <TooltipCp v-if="module==4" :timeLabelLocal="timeLabelLocal" :tData="currentTooltipData"
                    :hideCustomTooltip="hideCustomTooltip"/>


      </div>
    </div>
  </div>

</template>

<script>
import * as echarts from 'echarts'
import chinaJson from '@/utils/china.json' // 确保你的 china.json 放在正确路径
import TooltipBgc from './mapComponents/tooltipBgc.vue'
import TooltipFxz from './mapComponents/tooltipFxz.vue'
import TooltipCp from './mapComponents/tooltipCp.vue'

export default {
  name: 'ChinaMap',
  components: {
    TooltipBgc,
    TooltipFxz,
    TooltipCp,
  },
  props: {
    module: {
      type: Number,
      default: 1
    },
    platform: {
      type: Number,
      default: 1
    },
    timeLabel: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
    },
    handlerDbClick: {
      type: Function,
      default: (params) => {
      }
    }
  },
  data() {
    return {
      chart: null,
      mapData: [],

      tooltipVisible: false,
      currentTooltipData: {},
      statusList: ['', '正在运营', '即将开放', '规划中'],


      clickTimer: null,
      clickDelay: 300, // 延迟时间，毫秒
    }
  },
  watch: {
    datas: {
      immediate: true,
      handler(newVal) {
        this.mapData = newVal
        if (newVal && newVal.length > 0) {
          this.mapData = newVal.map(m => ({
            ...m,
            statusStr: this.statusList[m.status],
            name: m.province_name,
            value: m.status
          }))

          this.chart?.setOption({
            series: [{
              data: this.mapData // newData 是你新的数据数组
            }]
          });
        } else {
          this.chart?.setOption({
            series: [{
              data: []
            }]
          });
        }
      }
    },
    // 添加对 module 的监听
    module() {
      this.hideCustomTooltip();
    },
    // 添加对 module 的监听
    platform() {
      this.hideCustomTooltip();
    }
  },
  computed: {
    timeLabelLocal() {
      if (this.timeLabel == '') return '本时段'
      return this.timeLabel;
    }
  },
  mounted() {
    echarts.registerMap('china', chinaJson)
    this.initChart()
    window.addEventListener('resize', this.handleResize)
    // 添加全局点击监听器来关闭 tooltip
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
    }
    // 移除全局点击监听器
    document.removeEventListener('click', this.handleDocumentClick)

  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart)

      const option = {
        tooltip: {
          show: false,
        },
        visualMap: {
          show: false,
          min: 1,
          max: 3,
          inRange: {
            color: ['#ffd33e', '#b25afe', '#29d7c3',]
          }
        },
        series: [
          {
            name: '中国',
            type: 'map',
            map: 'china',
            roam: false,
            zoom: 1.2,
            itemStyle: {
              areaColor: '#3552ae',
              borderColor: '#85dee8',
              borderWidth: 2,
            },
            // label: {
            //   show: true,
            //   color: 'black',
            //   fontSize: 12,
            //   formatter: (params) => {
            //     // 只有当 status 有值且不为 0 时才显示标签
            //     return params.data && params.data.value ? params.name : '';
            //   }
            // },
            emphasis: false,
            select: false,
            data: this.mapData
          }
        ]
      }

      this.chart.setOption(option)


      // 处理点击和双击事件
      let clickCount = 0;

      this.chart.on('click', params => {
        event.stopPropagation()

        // 清除之前的定时器
        clearTimeout(this.clickTimer);

        // 如果已经有一次点击记录，视为双击
        if (clickCount === 1) {
          clickCount = 0;
          this.handlerDbClick(params)
          return;
        }

        // 记录一次点击
        clickCount = 1;

        // 设置延迟处理单击事件
        this.clickTimer = setTimeout(() => {
          // 单击处理 - 显示 tooltip
          clickCount = 0;
          if (params.data && params.data.name && params.data.value >= 0) {
            this.showCustomTooltip(params);
          } else {
            this.hideCustomTooltip();
          }
        }, this.clickDelay);
      });

    },
    handleDocumentClick(event) {
      // 检查点击的元素是否在 tooltip 内部
      const tooltip = this.$refs.customTooltip
      if (tooltip && !tooltip.contains(event.target)) {
        this.hideCustomTooltip()
      }
    },
    showCustomTooltip(params) {
      const event = params.event
      const tooltip = this.$refs.customTooltip

      this.currentTooltipData = params.data

      let left = event.offsetX
      let top = event.offsetY

      tooltip.style.left = left + 'px'
      tooltip.style.top = top + 'px'

      this.tooltipVisible = true
    },
    hideCustomTooltip() {
      console.log('---close')
      this.tooltipVisible = false
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center_box {
  position: relative;
  width: 100%;
  height: 100%;
  // background-color: #000;
}

.view_box {
  width: 100%;
  height: 100%;
  position: relative;
}

.map_box {
  width: 100%;
  height: 100%;
}

.custom-tooltip {
  position: absolute;
  display: flex;
  justify-content: center;
  color: white;
  z-index: 99999;
  transform: translate(-50%, -102%); // 使tooltip中心对齐到鼠标位置
  pointer-events: auto; // 改为 auto，使元素可以接收鼠标事件
  user-select: none; // 防止文本选择
}

</style>